import { render, staticRenderFns } from "./ProgramChooser.vue?vue&type=template&id=3c1b1446&scoped=true&"
import script from "./ProgramChooser.vue?vue&type=script&lang=js&"
export * from "./ProgramChooser.vue?vue&type=script&lang=js&"
import style0 from "./ProgramChooser.vue?vue&type=style&index=0&id=3c1b1446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b1446",
  null
  
)

export default component.exports